module.exports = __webpack_public_path__ + "static/media/Hours50.25aa697e.png";